import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import InWikiEmailModule from './InWikiEmailModule';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
export const getInWikiEmailModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const props = buildModuleProps(moduleConfig);
    const reactRoot = document.createElement('div');
    reactRoot.style.display = 'none';
    // API
    const show = () => (reactRoot.style.display = '');
    const hide = () => (reactRoot.style.display = 'none');
    const render = () => {
        ReactDOM.render(React.createElement(InWikiEmailModule, {
            onClose: hide,
            config: moduleConfig.config,
            track: props.track,
        }), reactRoot);
        return reactRoot;
    };
    return {
        render,
        show,
        hide,
    };
});
